export default {
  CURRENT_CYCLE: 'current-cycle',
  NEXT_CYCLE: 'next-cycle'
};